import React, { useRef } from 'react';
import Slider from 'react-slick';
import styles from '../dani_monteiro_designer/dani_monteiro_designer.module.scss';
import Perfil from './src/perfil.png';
import LinkPersonalizado from '../../components/LinkPersonalizado/linkPersonalizado.tsx';
import InstagramIcon from '../../icons/instagramIcon.tsx';
import WhatsappIcon from '../../icons/whatsappIcon.tsx';
import MapsIcon from '../../icons/mapsIcon.tsx';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import catalogoPdf from './src/catalogo.pdf';

// Imagens do carrossel
import ImagemServico1 from './src/1.jpeg';
import ImagemServico2 from './src/2.jpeg';
import ImagemServico3 from './src/3.jpeg';
import ImagemServico4 from './src/4.jpeg';
import ImagemServico5 from './src/5.jpeg';
import ImagemServico6 from './src/6.jpeg';
import ImagemServico7 from './src/7.jpeg';
import ImagemServico8 from './src/8.jpeg';
import ImagemServico9 from './src/9.jpeg';
import ImagemServico10 from './src/10.jpeg';
import ImagemServico11 from './src/11.jpeg';
import ImagemServico12 from './src/12.jpeg';
import ImagemServico13 from './src/13.jpeg';
import ImagemServico14 from './src/14.jpeg';
import ImagemServico15 from './src/15.jpeg';
import ImagemServico16 from './src/16.jpeg';
import ImagemServico17 from './src/17.jpeg';
import ImagemServico18 from './src/18.jpeg';
import ImagemServico19 from './src/19.jpeg';
import ImagemServico20 from './src/20.jpeg';
import ImagemServico21 from './src/21.jpeg';
import ImagemServico22 from './src/22.jpeg';
import ImagemServico23 from './src/23.jpeg';
import ImagemServico24 from './src/24.jpeg';
import ImagemServico25 from './src/25.jpeg';
import ImagemServico26 from './src/26.jpeg';
import ImagemServico27 from './src/27.jpeg';
import ImagemServico28 from './src/28.jpeg';
import ImagemServico29 from './src/29.jpeg';
import ImagemServico30 from './src/30.jpeg';
import ImagemServico31 from './src/31.jpeg';
import ImagemServico32 from './src/32.jpeg';
import ImagemServico33 from './src/33.jpeg';
import ImagemServico34 from './src/34.jpeg';
import ImagemServico35 from './src/35.jpeg';
import ImagemServico36 from './src/36.jpeg';
import ImagemServico37 from './src/37.jpeg';
import ImagemServico38 from './src/38.jpeg';
import ImagemServico39 from './src/39.jpeg';
import ImagemServico40 from './src/40.jpeg';
import ImagemServico41 from './src/41.jpeg';
import ImagemServico42 from './src/42.jpeg';
import ImagemServico43 from './src/43.jpeg';
import ImagemServico44 from './src/44.jpeg';
import ImagemServico45 from './src/45.jpeg';
import ImagemServico46 from './src/46.jpeg';
import ImagemServico47 from './src/47.jpeg';
import ImagemServico48 from './src/48.jpeg';
import ImagemServico49 from './src/49.jpeg';
import ImagemServico50 from './src/50.jpeg';
import ImagemServico51 from './src/51.jpeg';
import ImagemServico52 from './src/52.jpeg';
import ImagemServico53 from './src/53.jpeg';
import ImagemServico54 from './src/54.jpeg';
import ImagemServico55 from './src/55.jpeg';
import ImagemServico56 from './src/56.jpeg';
import ImagemServico57 from './src/57.jpeg';
import ImagemServico58 from './src/58.jpeg';
import ImagemServico59 from './src/59.jpeg';
import CatalogIcon from '../../icons/catalogIcon.tsx';

const Dani_monteiro_designer: React.FC = () => {
    const imgRef = useRef<HTMLImageElement>(null);

    // Configurações do carrossel
    const settings = {
        dots: false,
        infinite: true,
        arrows: false,
        speed: 1000,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000
    };

    const images = [
        { src: ImagemServico1, title: "Imagem Serviço", description: "" },
        { src: ImagemServico2, title: "Imagem Serviço", description: "" },
        { src: ImagemServico3, title: "Imagem Serviço", description: "" },
        { src: ImagemServico4, title: "Imagem Serviço", description: "" },
        { src: ImagemServico5, title: "Imagem Serviço", description: "" },
        { src: ImagemServico6, title: "Imagem Serviço", description: "" },
        { src: ImagemServico7, title: "Imagem Serviço", description: "" },
        { src: ImagemServico8, title: "Imagem Serviço", description: "" },
        { src: ImagemServico9, title: "Imagem Serviço", description: "" },
        { src: ImagemServico10, title: "Imagem Serviço", description: "" },
        { src: ImagemServico11, title: "Imagem Serviço", description: "" },
        { src: ImagemServico12, title: "Imagem Serviço", description: "" },
        { src: ImagemServico13, title: "Imagem Serviço", description: "" },
        { src: ImagemServico14, title: "Imagem Serviço", description: "" },
        { src: ImagemServico15, title: "Imagem Serviço", description: "" },
        { src: ImagemServico16, title: "Imagem Serviço", description: "" },
        { src: ImagemServico17, title: "Imagem Serviço", description: "" },
        { src: ImagemServico18, title: "Imagem Serviço", description: "" },
        { src: ImagemServico19, title: "Imagem Serviço", description: "" },
        { src: ImagemServico20, title: "Imagem Serviço", description: "" },
        { src: ImagemServico21, title: "Imagem Serviço", description: "" },
        { src: ImagemServico22, title: "Imagem Serviço", description: "" },
        { src: ImagemServico23, title: "Imagem Serviço", description: "" },
        { src: ImagemServico24, title: "Imagem Serviço", description: "" },
        { src: ImagemServico25, title: "Imagem Serviço", description: "" },
        { src: ImagemServico26, title: "Imagem Serviço", description: "" },
        { src: ImagemServico27, title: "Imagem Serviço", description: "" },
        { src: ImagemServico28, title: "Imagem Serviço", description: "" },
        { src: ImagemServico29, title: "Imagem Serviço", description: "" },
        { src: ImagemServico30, title: "Imagem Serviço", description: "" },
        { src: ImagemServico31, title: "Imagem Serviço", description: "" },
        { src: ImagemServico32, title: "Imagem Serviço", description: "" },
        { src: ImagemServico33, title: "Imagem Serviço", description: "" },
        { src: ImagemServico34, title: "Imagem Serviço", description: "" },
        { src: ImagemServico35, title: "Imagem Serviço", description: "" },
        { src: ImagemServico36, title: "Imagem Serviço", description: "" },
        { src: ImagemServico37, title: "Imagem Serviço", description: "" },
        { src: ImagemServico38, title: "Imagem Serviço", description: "" },
        { src: ImagemServico39, title: "Imagem Serviço", description: "" },
        { src: ImagemServico40, title: "Imagem Serviço", description: "" },
        { src: ImagemServico41, title: "Imagem Serviço", description: "" },
        { src: ImagemServico42, title: "Imagem Serviço", description: "" },
        { src: ImagemServico43, title: "Imagem Serviço", description: "" },
        { src: ImagemServico44, title: "Imagem Serviço", description: "" },
        { src: ImagemServico45, title: "Imagem Serviço", description: "" },
        { src: ImagemServico46, title: "Imagem Serviço", description: "" },
        { src: ImagemServico47, title: "Imagem Serviço", description: "" },
        { src: ImagemServico48, title: "Imagem Serviço", description: "" },
        { src: ImagemServico49, title: "Imagem Serviço", description: "" },
        { src: ImagemServico50, title: "Imagem Serviço", description: "" },
        { src: ImagemServico51, title: "Imagem Serviço", description: "" },
        { src: ImagemServico52, title: "Imagem Serviço", description: "" },
        { src: ImagemServico53, title: "Imagem Serviço", description: "" },
        { src: ImagemServico54, title: "Imagem Serviço", description: "" },
        { src: ImagemServico55, title: "Imagem Serviço", description: "" },
        { src: ImagemServico56, title: "Imagem Serviço", description: "" },
        { src: ImagemServico57, title: "Imagem Serviço", description: "" },
        { src: ImagemServico58, title: "Imagem Serviço", description: "" },
        { src: ImagemServico59, title: "Imagem Serviço", description: "" },
    ];

    return (
        <div className={styles.dani_monteiro_designer}>

            <div className={styles["body-thunder"]}>
                <div className={styles["background-thunder"]}></div>
                <div className={styles["container-thunder"]}>
                    <div className={styles["img-wrapper"]}>
                        <img
                            ref={imgRef}
                            className={styles["img-perfil"]}
                            src={Perfil}
                            alt="Profile Picture"
                        />
                    </div>
                    <h1 className="mb-0">DANI MONTEIRO</h1>
                    <p className="mb-3">DESIGNER</p>
                    <div className={styles.links}>
                        <LinkPersonalizado
                            href="https://wa.me/5517981573810?text=Olá, gostaria de mais informações..."
                            title="Whatsapp"
                            icon={<WhatsappIcon height="40" color="#E75480" />}
                            colorText="#000"
                            tipo="rosa"
                        />
                        <LinkPersonalizado
                            href="https://www.instagram.com/dani.monteiro.designer?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                            title="Instagram"
                            icon={<InstagramIcon height="32" color="#E75480" />}
                            colorText="#000"
                            tipo="rosa"
                        />
                        <LinkPersonalizado
                            href="/dani_monteiro_designer/catalogo"
                            // href={catalogoPdf}
                            title="Catálogo"
                            icon={<CatalogIcon height="34" color="#E75480" />}
                            colorText="#000"
                            tipo="rosa"
                        />
                        <LinkPersonalizado
                            href="https://maps.app.goo.gl/FoqH2gYYrQ3v3AqG6"
                            title="Localização"
                            icon={<MapsIcon height="40" color="#E75480" />}
                            colorText="#000"
                            tipo="rosa"
                        />
                    </div>
                    <div className={`${styles["card"]} pb-4`}>
                        <h2 className={styles["carousel-title"]}>Serviços</h2>
                        <Slider {...settings}>
                            {images.map((image, index) => (
                                <div key={index} className={styles["carousel-item"]}>
                                    <img className={styles["carousel-image"]} src={image.src} alt={image.title} />
                                </div>
                            ))}
                        </Slider>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Dani_monteiro_designer;
